module.exports = __webpack_public_path__ + "img/bg_f5.e3d4bb1a.png";